import { useQuery } from '@tanstack/react-query'

import axiosInstance from '@/libs/configs/axios'
import {
  ERewardType,
  SURVEY_CATEGORY,
  SURVEY_PROVIDER,
  TApiResult,
} from '@/libs/types/global.types'

export const SURVEY_DETAIL_QUERY_KEY = 'survey_detail'

export type TDetailSurveyPayload = {
  survey_id: string
}

export type TSurveyData = {
  id: string
  name: string
  start_date: Date
  end_date: Date
  reward_type: ERewardType
  reward_amount: number
  availabilityStatus: string
  submission_max_time: number
  required_participant: number
  fulfilled_participant: number
  is_welcome_survey: boolean
  surveyType: SURVEY_CATEGORY
  surveyProvider: SURVEY_PROVIDER
  lengthOfSurvey: number
}

const getDetailSurveyAPI = async ({ survey_id }: TDetailSurveyPayload) =>
  axiosInstance<TApiResult<TSurveyData>>({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    url: `/survey/user/surveys/${survey_id}`,
  })

export default function useGetDetailSurveyQuery({ survey_id }: TDetailSurveyPayload) {
  return useQuery({
    queryKey: [SURVEY_DETAIL_QUERY_KEY, survey_id],
    queryFn: () => getDetailSurveyAPI({ survey_id }),
  })
}
